<template>
  <div class="league-selector">
    <span class="league-label">Leagues</span>
    <div class="league-progress">
      <div
        v-for="(league, index) in leagues"
        :key="league.id"
        class="league-step"
        :class="{
          filled: isLevelFilled(index),
          locked: league.locked,
        }"
        @click="selectLeague(league)"
      >
        <span v-if="index > 0" class="league-connector" :class="{ filled: isLevelFilled(index) }"></span>
        <div class="league-node">
          <v-icon
            class="league-icon"
            :style="{ color: league.color }"
            x-small
          >fa-medal</v-icon>
          <span class="league-circle"></span>
          <v-icon v-if="league.locked" class="lock-icon" x-small>fa-lock</v-icon>
        </div>
              </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeagueSelector',
  props: {
    value: {
      type: String,
      default: 'bronze'
    }
  },
  data() {
    return {
      selectedLeague: this.value,
      leagues: [
        { id: 'bronze', name: 'Bronce', color: '#CD7F32', locked: false },
        { id: 'silver', name: 'Plata', color: '#C0C0C0', locked: true },
        { id: 'gold', name: 'Oro', color: '#FFD700', locked: true }
      ]
    };
  },
  computed: {
    selectedIndex() {
      return this.leagues.findIndex(l => l.id === this.selectedLeague);
    }
  },
  watch: {
    value(newVal) {
      this.selectedLeague = newVal;
    }
  },
  methods: {
    selectLeague(league) {
      if (league.locked) return;
      this.selectedLeague = league.id;
      this.$emit('input', league.id);
      this.$emit('change', league.id);
    },
    isLevelFilled(index) {
      return index <= this.selectedIndex;
    }
  }
};
</script>

<style scoped lang="scss">
$filled-color: #E53935;
$empty-color: #E0E0E0;

.league-selector {
  display: flex;
  align-items: center;
  gap: 12px;
}

.league-label {
  font-family: 'Avenir', sans-serif;
  font-weight: 600;
  font-size: 13px;
  color: var(--v-mainBlack-base);
}

.league-progress {
  display: flex;
  align-items: center;
}

.league-step {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;

  &:hover .league-circle {
    transform: scale(1.15);
  }

  &.locked {
    cursor: not-allowed;
    opacity: 0.6;

    &:hover .league-circle {
      transform: none;
    }
  }
}

.league-connector {
  width: 20px;
  height: 6px;
  background-color: $empty-color;
  transition: background-color 0.3s ease;
  align-self: flex-end;
  margin-bottom: 5px;

  &.filled {
    background-color: $filled-color;
  }
}

.league-node {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  position: relative;
}

.league-icon {
  font-size: 14px !important;
}

.league-circle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: $empty-color;
  transition: background-color 0.3s ease, transform 0.2s ease;

  .filled & {
    background-color: $filled-color;
  }
}

.lock-icon {
  position: absolute;
  bottom: -2px;
  right: -6px;
  font-size: 10px !important;
  color: #666;
  background: white;
  border-radius: 50%;
  padding: 2px;
}

.theme--dark .league-selector {
  .league-label {
    color: var(--v-fullWhite-base);
  }

  .lock-icon {
    background: #424242;
    color: #9ca3af;
  }
}
</style>
